/** @jsx h */
import { connect } from 'redux-bundler-preact'
import { h } from 'preact'

const baseClasses =
  'fixed tr-tr z-999 bg-dark-gray light-silver w5 h-100 overflow-y-auto flex-shrink-0'
const largeClasses = 'trl0-l'

const Drawer = ({ children, drawerIsOpen, showShield, className }) => (
  <div>
    <div
      className={
        showShield ? 'fixed aspect-ratio--object bg-black-70 h0-l' : null
      }
    />
    <div
      className={`${baseClasses} ${largeClasses} ${
        drawerIsOpen ? 'trl0' : 'trl-5'
      } ${className}`}
    >
      {children}
    </div>
  </div>
)

export default connect('selectShowShield', 'selectDrawerIsOpen', Drawer)
